import React from 'react';
import { withStyles, Hidden } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';

const styles = theme => ({
    container: {
        marginBottom: '10px',
        padding: '25px 42px 25px 42px',
        minWidth: 'min-content'
    },
    minHeight: {
        minHeight: '620px'
    },
    mediumContainer: {
        backgroundColor: 'white',
        height: 'calc(100vh - 64px)'
    },
    smallContainer: {
        backgroundColor: 'white',
        height: 'calc(100vh - 58px)'
    },
    fullHeight: {
    }
});

class PageContainer extends React.Component {
    render() {
        const { children, classes, noMinHeight } = this.props;
        return (
            <>
                <Hidden smDown>
                    <Grid container justify='center'>
                        <Grid item xl={10} lg={10} md={12} sm={12} xs={12}>
                            <Grid container justify='center' component={Paper} direction={'column'} className={classNames(classes.container, noMinHeight !== true && classes.minHeight)}>
                                {children}
                            </Grid >
                        </Grid>
                    </Grid>
                </Hidden>
                <Hidden mdUp xsDown>
                    <Grid container className={classNames(classes.mediumContainer)}>
                        {children}
                    </Grid >
                </Hidden>
                <Hidden smUp>
                    <Grid container className={classNames(classes.smallContainer)}>
                        {children}
                    </Grid >
                </Hidden>
            </>
        );
    }
};

export default withStyles(styles)(PageContainer);